<div class="page-shell">
  <mat-toolbar class="header">
    <span>{{ 'planned.header' | translate }}</span>
    <div class="actions">
      <a mat-stroked-button [routerLink]="['/wizard']">{{ 'planned.new' | translate }}</a>
    </div>
  </mat-toolbar>

  <div class="content-wrapper">
    <p class="page-info">{{ 'planned.info' | translate }}</p>

    <div
      class="table-container"
      [class.table-container--empty]="!isLoading && dataSource.data.length === 0"
      [class.table-container--loading]="isLoading"
    >
      <mat-table matSort [dataSource]="dataSource" class="planned-table">
        <ng-container matColumnDef="templateName">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'planned.name' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <div *ngIf="element.templateName">{{ element.templateName }}</div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="dateUtc">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'planned.date' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <div *ngIf="element.dateUtc">{{ element.dateUtc | localizedDate }}</div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="context">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'planned.destination' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <div *ngIf="element.context">{{ toDestination(element.context) | translate }}</div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="type">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'planned.typeLabel' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <div *ngIf="element.type">
              {{ 'planned.type.' + element.type | translate }}
              <div *ngIf="element.type === 'ABSENCE'">{{ element.dateUtc | localizedDate:'medium' }}</div>
            </div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="cancel">
          <mat-header-cell *matHeaderCellDef>{{ 'cancel' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <div class="table-actions" *ngIf="element.type === 'PLANNER'">
              <button
                type="button"
                class="action-btn action-btn--danger"
                (click)="remove(element.templateCronId)"
              >
                <mat-icon>close</mat-icon>
                {{ 'cancel' | translate }}
              </button>
            </div>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
      </mat-table>

      <div class="loading-wrapper" *ngIf="isLoading">
        <app-loading></app-loading>
      </div>

      <div class="empty-state" *ngIf="!isLoading && dataSource.data.length === 0">
        <mat-icon class="empty-state__icon">event</mat-icon>
        <p>{{ 'planned.empty' | translate }}</p>
      </div>
    </div>
  </div>
</div>
